const STATUS_OK_MIN = 200;
const STATUS_OK_MAX = 299;
const STATUS_FORBIDDEN = 403;
const STATUS_SERVER_MIN = 500;
const STATUS_REQUEST_TIMEOUT = 408;
const STATUS_TOO_MANY_REQUESTS = 429;
const TRANSIENT_STATUSES = Object.freeze([STATUS_REQUEST_TIMEOUT, STATUS_TOO_MANY_REQUESTS]);

const failureOf = (status) => {
    if (status === STATUS_FORBIDDEN) return { kind: 'expired', status };
    if (status >= STATUS_SERVER_MIN || TRANSIENT_STATUSES.includes(status)) return { kind: 'server', status };
    return { kind: 'http', status };
};

const isOk = (status) => status >= STATUS_OK_MIN && status <= STATUS_OK_MAX;

const stallGuard = (xhr, stallMs, reject) => {
    const stall = { timer: null };
    return {
        arm: () => {
            clearTimeout(stall.timer);
            stall.timer = setTimeout(() => {
                xhr.abort();
                reject({ kind: 'stall', status: 0 });
            }, stallMs);
        },
        clear: () => clearTimeout(stall.timer),
    };
};

const sendWithXhr = ({ url, blob, contentType, stallMs, onProgress = () => {} }, resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const guard = stallGuard(xhr, stallMs, reject);
    xhr.open('PUT', url);
    if (contentType) xhr.setRequestHeader('Content-Type', contentType);
    xhr.upload.onprogress = (event) => {
        guard.arm();
        onProgress(event.loaded);
    };
    xhr.onerror = () => {
        guard.clear();
        reject({ kind: 'network', status: 0 });
    };
    xhr.onload = () => {
        guard.clear();
        if (isOk(xhr.status)) resolve({ status: xhr.status });
        else reject(failureOf(xhr.status));
    };
    guard.arm();
    xhr.send(blob);
};

export const putBlob = (options) => new Promise((resolve, reject) => sendWithXhr(options, resolve, reject));
